<template>
    <div class="login">
        <dialog open>
            <form @submit.prevent="loginSubmit" class="login__form">
                <input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response">
                <input type="hidden" name="action" value="validate_captcha">
                <img src="/img/common/doctu_rus.small.png" alt="" width="137" height="35">
                <label class="mt-2">
                    <span>Имя пользователя:</span>
                </label>
                <input ref="loginInput" autofocus name="login" v-model="login" class="large" required/>
                <label class="mt-2">
                    <span>Пароль:</span>
                </label>
                <div class="password-container" style="width: 100% !important;">
                    <input :type="this.showPass ? 'text' : 'password'" v-model="password"  name="password" class=" large"/>
                    <img @click="toggleShowPass" class="password-container__tag" :src="passwordTagImage" alt="">
                </div>
                <span v-if="errorMessage.length" class="mt-2 error">{{errorMessage}}</span>
                <button class="mt-2" :class="loading ? 'loading' : ''" type="submit" width="100%">Войти</button>
                <div class="register mt-2">
                    <a  href="https://doctu.ru/for-clinics#form" target="_blank">Зарегистрироваться</a>
                    <a @click.prevent="showRestore">Забыли пароль</a>
                </div>
            </form>
        </dialog>
        <div v-if="showRestoreDialog" style="background-color: rgba(255,255,255,.8); position: absolute; z-index: 10000; width: 100vw; height: 100vh">
            <Restore ref="restore" @hide-restore="hideRestore" />
        </div>
    </div>
</template>

<script>
    import Restore from "@pages/auth/Restore";
    export default {
        name: "Login",
        components: {Restore},
        data() {
            return {
                showPass: false,
                password: '',
                login: '',
                email: '',
                showRestoreDialog: false,
                loading: false,
                errorMessage: '',
            }
        },
        computed: {
            passwordTagImage() {
                return !this.showPass
                    ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAESUlEQVR4Xu2ZjbENQRCFz4uADBABIkAEiAARIAJEgAgQASJABJ4IEAEioD61/Wpe35np2Z+7Vu101dZVdne6+8w53b3zTrRzO9l5/uoAdAbsHIEugZ0ToBfBLoEugZ0j0CWwcwL0LtAl0CWwDgI3JN2UdHm4Lkq65lyfSvop6dtwfZT06djhHUsCJHpb0p0h8Tl5AMQ7Se8HYOasdfDu0gDck3R/gaRLSQLGa0lvlkJhCQCg88MhcXZ+DUMmAPFykM1kn3MBeCLpkSRAqNl3SewegfOL2a+9R43ArFbweylYl5qB/8mMmAoAwb0aClopxi/DLqFfEp9iMIo6gqyuVhZg/QcZUEOfYwFgp0mcoHL2ayhYLyRR1Zc0uga7TZ0pGWADBMxosjEAkDTJ1+gOFdmtYxrar4FA8oAAGKG1AvB8QD9a8Eoj3a1o2iwAW2BNi5aRxdcokGG9x9FzEQDs9ofM0JJbF8374cY/F60HELcaKMxztZpgfsP1agCQDMnnKE/7sWHHnIE2u1izzw0gEfT1YJ2nkuhAZjYkwSxvSAJQszWpBAA6hvY+eYoc99AXbYwR1wwnvrWlwVDAWLPF0DBaLxldiM0xY2Tm/6hTvHfBvVisCzkASJBi5w2K48Ba2m/3QCSnlt23JSMWsDE/Cv5hJhuUk8gBsD7oUvJQjHtpexkLgH8+YkIEaM0/AMEEvke8nQMhdVJKvtTatgyAJV1qmWcgGAAUPCjqrdbXYUOqtagFtlZuYog6io+X2lSaT0ogUGhPDQBfVFIEQStnWyyCuTipZ7nh7BwAvFiSAAjmQPDIPpNEe6pZCwui3Wd93wZLTC0lfyABC7oGAn0+LYK+rUWVGx/QFOaUhhiSh43RLO87iq/u+KHl5na+WAQjEPxUlRtJozqQ+gBAA4LEGaJqvd/ejfxy/21h4ArboDmpDRR33Td9Ogz9i48hG4KIHfaQfG2AOyfRaBSGrn6qMg2i+Zxk/haXqMlPvJ/rVrarjMa5GkSHAJhRo7DFV9MsC9r8n2qaSREQIh2PxYBY0H567IZ0rBblPsTCmhJNWxYk+sx9aHAfILxzRlGksqRBbX8Qk/NtPvlgA5yqtQJg+qJIRed05jD8FI2CG+5Hn9B+Gc4fkWbtw+zsnTEAWBuDDbUTmTQgk0lTMBlA0C7tLDpnsFcpwux6s/zGAmCOCAwgWg4leAfmUDRbD0fROUWt9XjNasFooKcCYEAQIJW3VRYEaBdB205Bc8AEWLtaFALd8d8yP2TXmwvAVCBakqs9MztxW3wpAGw9O8PPfYfPTZr3OZdgt5tOfFscLg2A+YTSgME1FwySJmGu5uLWkjzPHAsA758qbn/y4t+m+fQ5qwl0DvsT2rEmysltsBXY/+a5tRiwWUA6AJvdmpUC6wxYCejNuukM2OzWrBRYZ8BKQG/WTWfAZrdmpcA6A1YCerNuOgM2uzUrBfYH/6zsQTLY9P4AAAAASUVORK5CYII='
                    : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEhklEQVR4Xu2ajZFMQRCA+yJABIgAESACRIAIEAEiQARcBIgAESACRIAIqE9tX8319kxPz3u37mZvqrZu7Xtvuvub/pt5DmTPx8Ge2y/nAM49oE3gioh8nxlSKwQeiMhrEXkoIm9mhVADoMar3dNC8ADg9t+cFZ8SQq8HTOsJPTnAOsNUnhD1ATYXTOcJEQAMnhpCD4CpIfQCmBZCBsCUELIApoMwAmAEwnURuSkiNFl85y+fcrDnKD8fReTTSbfgowAiCO9E5I6I3BWRWyJycYEhgGC+QxH5tWAe99ElAFoQ1tZT5wMEG7P3awlYCuB/QEAmofJs4xWLWKwBoAfCbxHBlb9s/uLKfNdBiJAbGIQM3/lcDqxbDGIUAArbeKx1jK9E5PHgMgGBPMLcLRjAfLKBmxKVBYDhTzcK3TarGCXGpYcqeAYg7jcsfCkizzPJMgMABd4WGR0P2DUEbAdkCwJhwY6VkAtHL4AXFTcehYABhIXGPS7M6lHqolE7sLHPMR9h0RwRAFz+Q6GoN1kWAitkmyCdFxB4VVTvue9aZNzGC+615msBYHUw3mtiSGwYQbPDQOGricTY0h3jbgTGUQLJRTroCwD7yHmO34FQVp2j22oAyLycCFvjKWdcI7740N7qYOW8uKtVh5aN0akT+YjF0UHLzG98aJYumMlZICBs6ecBqCmMEIxX9/xjhFxquFoWQuQFLMxPI19t4RqGeiGyBdYCqClKcuJaOSyAKJ9kIUTzRfJr1eIYhFJI9ugrUsBz8QyEpQCQT6WhgtlxBEGFkPA+t250rhEKZayRuNxEY57tgfA1qDxWX3JTbcdZk/dPXwVgk4rq3EpGvUlwxBNGk2BG1jEAPFgjhRtR9uywMUYLSnnqHTV5Pxp9gs5ty6CXo7iXskhDFIaA3lBTCmNZlXLY+Ioyd2Z1Ig8gXLWLZF7vfsq4Tdxb92bKIAZSS/V1udeS0gxlX6dnk28kt9W9hmVQV6nVUDAJzQbD5gF+B1J2ZCCwIaMf0UEXqP9uNXDYtJWko1YYg7x9uG47VWBpcK0jjKD0QPCStXZ4tMbeuQMVhblTrbAqizsBoWx59Rquzm6LhFR2XfxOho02NNmcgB68ti/LHd0p8ol3b4Nlu9ctmVGzoQ/YrFtO5O3uRhJilIg9Oa2dZVdV6gWAcrgf1SA6p1NDere2GU+IwojrlFFCs6cpS/83OdwPb/C2nZ5yqdMZM0FPx2hlsurkp+7wy3hAKYwajCAvN3ggiF/yxVol0sog1kmAXatePjwKoIxXPCITFsCgfNK/q8J4FokU97WQWp7A/VzvOv/zVmYpgFEQtVjOHq9FHWOYM9YCoIJ6jq4jpXYKYW0AZf+gL0b5a4+oTg2EkwJgDdRXXTQreAmjTKBlPiAvkAf0VZqdq6djjAAfXd8VgG6FOm9cDcJZBQCnVSCcZQCrQDjrABZDmAHAIgizABiGMBOAIQizAUhDmBFAC8LWcd2sADwI7ruDmQGUEGovTtInQp2d6qm6jb1H9bxgdg8IV+IcQIho8hv23gP+Ak1HM1BAtIt+AAAAAElFTkSuQmCC';
            }
        },
        updated() {
            if (this.showRestoreDialog) {
                this.$nextTick(() => {
                    this.$refs.restore.$refs.input.focus();
                })
            }
        },
        methods: {
            toggleShowPass() {
                this.showPass = !this.showPass;
            },
            loginSubmit() {
                this.loading = true;
                this.axios.post('login', {
                    login: this.login,
                    password: this.password,
                    returnPage: new URL(location.href).searchParams.get('returnPage'),
                })
                    .then((res) => {
                        this.$nextTick().then(() => {
                            window.location.href = res.data.redirect
                        })
                    }).catch((error) => {
                        let errors = Object.values(error.errors)
                        let message = errors[0];
                        if (Array.isArray(message)) {
                            message =  message[0];
                        }
                        this.errorMessage = message
                        this.loading = false;
                    })
            },
            hideRestore() {
                this.showRestoreDialog = false;
            },
            showRestore() {
                this.showRestoreDialog = true;
            },

        }
    }
</script>

<style scoped lang="scss">
    dialog {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
        width: auto;
        background: 0 0;
        text-align: left;
        min-height: initial;
        border-style: solid;
        border-width: 32px 41px 50px;
        border-image: url(data:image/png;base64,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) 32 41 50 fill stretch;
        box-sizing: border-box;
    }
    label {
        width: 100%;
        display: flex;
        justify-content: flex-start;
    }
    .mt-2 {
        margin-top: 2.2rem;
    }
    .error {
        color: darkred;
    }
    .login {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        &__form {
            width: 29rem;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
    .password-container {
        position: relative;
        &__tag{
            position: absolute;
            left: 26rem;
            top: 0.5rem;
            width: 26px;
        }
    }
    .register {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 1.4rem;
    }
    .checkbox {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        &__input {
            margin-left: 0!important; //TODO где-то в общих стилях стоит -20px
        }
        &__title {
            font-size: 1.7rem;
            color: black;
        }
    }
</style>
